module.exports = __webpack_public_path__ + "img/b02f15266a4c2b004679ce9cf1646d35.png";